class ProductAddOnModal extends HTMLElement {
    constructor() {
        super();
        this.modalOuter = this.querySelector('.product-add-on-modal__outer');
        this.openModal = this.openModal.bind(this);
        this.handleClicks = this.handleClicks.bind(this);
    }

    connectedCallback() {
        document.addEventListener('add-on:modal:open', this.openModal);
        document.addEventListener('click', this.handleClicks);
    }

    openModal(e) {
        if (!this.modalOuter) return;

        this.modalOuter.classList.add('is-active');
        document.body.classList.add('no-scroll');
    }

    handleClicks(e) {
        const outer = e.target.closest('.product-add-on-modal__outer');
        const inner = e.target.closest('.product-add-on-modal__inner');
        const closer = e.target.closest('.modal-closer');

        if (outer && !inner || closer) {
            this.modalOuter.classList.remove('is-active');
            document.body.classList.remove('no-scroll');
        }
    }
}

customElements.define('product-add-on-modal', ProductAddOnModal);